export var getTagsWithPlatfromTag = function getTagsWithPlatfromTag(tags) {
  var defaultTags = ['atlaskit'];
  if (!tags) {
    return defaultTags;
  }
  return defaultTags.concat(tags);
};